var map = {
	"./assets/PH-MAP 1.png": 7553,
	"./assets/Traxionpay-digicoop-coopnet.png": 7911,
	"./assets/aboutcoopnet/accesible.c0d72528.png": 7293,
	"./assets/aboutcoopnet/coop-centric.50c7086e.png": 9987,
	"./assets/aboutcoopnet/empowered.ca0e59a1.png": 2626,
	"./assets/aboutcoopnet/innovative.29785f98.png": 7869,
	"./assets/aggregatedpartners/partners.png": 5367,
	"./assets/aggregatedpartners/partners2.png": 2008,
	"./assets/cat_logo.webp": 5449,
	"./assets/contactus/coopnet-bg.c9a3a6f8.png": 3556,
	"./assets/contactus/manila.jpg": 9367,
	"./assets/contactus/not used/pic.5d925de4.png": 2097,
	"./assets/contactus/not used/traxion-group-photo.png": 7434,
	"./assets/contactus/tagum-and-davao.jpg": 2321,
	"./assets/coop-mobile.791fa1f6.png": 2060,
	"./assets/coopnet-logo-2.afcec3ef.png": 7962,
	"./assets/coopnet-logo.94f920f2.png": 6527,
	"./assets/coopnet.png": 3413,
	"./assets/coopnet_logo_colored.png": 5677,
	"./assets/coopnetmachine/CTM-Animation.gif": 5745,
	"./assets/coopnetmachine/banktransfer.png": 5298,
	"./assets/coopnetmachine/billspayment.png": 7433,
	"./assets/coopnetmachine/cashin.png": 6050,
	"./assets/coopnetmachine/coopnet-bg.c9a3a6f8.png": 7973,
	"./assets/coopnetmachine/eload.png": 8353,
	"./assets/coopnetmachine/fundtransfer.png": 8807,
	"./assets/coopnetmachine/loanapplication.png": 8456,
	"./assets/coopnetmachine/more.png": 1384,
	"./assets/coopnetmachine/remittance.png": 7619,
	"./assets/ctm-sidever.ea53acd5.png": 690,
	"./assets/digicoop.png": 3357,
	"./assets/dragonpaysuccesspage/digicoop_online_payment_flatline.png": 8898,
	"./assets/dragonpaysuccesspage/online_payment_flatline.png": 6132,
	"./assets/error-image.webp": 5728,
	"./assets/footer/coopnet-logo-3.3a936e31.png": 6702,
	"./assets/footer/facebook.1ab1b99b.png": 2513,
	"./assets/footer/linkedin.76ac1988.png": 6197,
	"./assets/footer/twitter.a16bac27.png": 6669,
	"./assets/footer/youtube.png": 1480,
	"./assets/gcash_logo.webp": 1746,
	"./assets/home-bg.a2b2cbed.png": 287,
	"./assets/meta/coopnet-banner.png": 4698,
	"./assets/meta/traxionpay-banner.png": 8341,
	"./assets/mobilebankingapp/Googleplay 1.png": 6739,
	"./assets/mobilebankingapp/appgallery 1.png": 3196,
	"./assets/mobilebankingapp/appstore 1.png": 1922,
	"./assets/mobilebankingapp/banktransfer.png": 106,
	"./assets/mobilebankingapp/billspayment.png": 5503,
	"./assets/mobilebankingapp/cashin.png": 3850,
	"./assets/mobilebankingapp/coopnet-mobile 1.png": 5109,
	"./assets/mobilebankingapp/ellipse-background.png": 8748,
	"./assets/mobilebankingapp/eload.png": 3862,
	"./assets/mobilebankingapp/fundtransfer.png": 6549,
	"./assets/mobilebankingapp/loanapplication.png": 7952,
	"./assets/mobilebankingapp/mobilebankingapp-bg.png": 6792,
	"./assets/mobilebankingapp/mobilebankingapp-logo.png": 9398,
	"./assets/mobilebankingapp/more.png": 3684,
	"./assets/mobilebankingapp/old/coopnet-mobile 1 (2).png": 3956,
	"./assets/mobilebankingapp/old/coopnet-mobile 1.png": 1225,
	"./assets/mobilebankingapp/remittance.png": 2762,
	"./assets/ourdxbanksolutions/Coopnet Teller Machine (CTM) - Cash in Cash out.png": 8328,
	"./assets/ourdxbanksolutions/Core Banking System on SAAS model.png": 1824,
	"./assets/ourdxbanksolutions/Digital Account Opening.png": 5604,
	"./assets/ourdxbanksolutions/Disbursement System.png": 306,
	"./assets/ourdxbanksolutions/Mobile Banking App.png": 6701,
	"./assets/ourdxbanksolutions/Payment System.png": 7986,
	"./assets/ourdxbanksolutions/Prepaid Debit Visa Card.png": 2256,
	"./assets/ourdxbanksolutions/eKYC.png": 9150,
	"./assets/ourdxbanksolutions/ewallet.png": 8619,
	"./assets/ourteam/Ann-Cuisia.png": 4834,
	"./assets/ourteam/Darwin-Pasco.png": 9395,
	"./assets/ourteam/Gari-Lenard-Santos.png": 2966,
	"./assets/ourteam/Mario-De-Guia.png": 7183,
	"./assets/ourteam/Rodel-Cayetano.png": 5788,
	"./assets/ourteam/Ronald-Cases-Morfe.png": 452,
	"./assets/receipt_check_mark.png": 214,
	"./assets/spinner.gif": 2328,
	"./assets/subscribe/mail.png": 7294,
	"./assets/success-logo.webp": 9337,
	"./assets/traxion-pay-black.png": 2118,
	"./assets/traxion-pay-white.png": 7975,
	"./assets/traxion.png": 534,
	"./assets/utilities/arrow-up-solid.svg": 9374,
	"./assets/whoweserve/coopbanks.1ae62676.png": 7462,
	"./assets/whoweserve/cooperatives.f10bc990.png": 1279,
	"./assets/whoweserve/lendingcompanies.1c9a7b0d.png": 7951,
	"./assets/whoweserve/microfinance.4274c5fb.png": 7637,
	"./assets/whoweserve/ruralbanks.f17e65df.png": 5722,
	"./assets/whoweserve/savingsbanks.230dfa81.png": 3193,
	"./assets/whoweserve/thriftbanks.cad7ce52.png": 5626,
	"./assets/whycoopnet/coin 1.png": 6348,
	"./assets/whycoopnet/coin 2.png": 1947,
	"./assets/whycoopnet/coin 3.png": 3052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;